module.exports = __webpack_public_path__ + "static/img/19-中国农业大学附属小学1.e51a354.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/19-中国农业大学附属小学1.png
// module id = X9kF
// module chunks = 0